import { prepareRequest } from "../../index.js";
import { setParamsToURL } from "../../index.js"
import { OFFER_API_URL_LIST }from "../../routes/offer/index.js";
import  store  from '../../../state/store';

async function getList(params, body, urlSegments) {
    let config= {
        headers:{
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "GET",
        url: setParamsToURL(OFFER_API_URL_LIST.LIST_URL,params,urlSegments),
        post: body
    }
    return prepareRequest(config,request,true);
}

async function getSingle(params, body, urlSegments) {
    let config= {
        headers:{
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "GET",
        url: setParamsToURL(OFFER_API_URL_LIST.SINGLE_URL,params,urlSegments),
        post: body
    }
    return prepareRequest(config,request,true);
}

async function addOffer(params, body) {
    let config= {
        headers:{
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "POST",
        url: setParamsToURL(OFFER_API_URL_LIST.ADD_URL,params),
        post: body
    }
    return prepareRequest(config,request);
}

async function updateOffer(params, body) {
    let config= {
        headers:{
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "POST",
        url: setParamsToURL(OFFER_API_URL_LIST.UPDATE_URL,params),
        post: body
    }
    return prepareRequest(config,request);
}


async function deleteOffer(params, body) {
    let config= {
        headers:{
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "POST",
        url: setParamsToURL(OFFER_API_URL_LIST.DELETE_URL,params),
        post: body
    }
    return prepareRequest(config,request);
}

async function approveOffer(params, body) {
    let config= {
        headers:{
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "POST",
        url: setParamsToURL(OFFER_API_URL_LIST.APPROVE_URL,params),
        post: body
    }
    return prepareRequest(config,request);
}

export { getList, addOffer, updateOffer, deleteOffer, getSingle, approveOffer };